import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme) => ({
  body: {
    "& .MuiPaper-root": {
      backgroundColor: theme.design.color.surface.raised,
      color: theme.design.color.text.primary,
      display: "flex",
      flexDirection: "column",
      borderRadius: "16px",
      fontFamily: theme.design.typography.fontFamily,
      fontWeight: 900,
      gap: 8,
    },

    "& .MuiDialog-paper": {
      overflowY: "initial",
    },
  },

  modalContent: {
    position: "relative",
    overflowY: "scroll",
  },

  closeIconBody: {
    display: "flex",
    justifyContent: "flex-end",
    position: "absolute",
    right: 25,
    top: 25,
    zIndex: 1,

    "&>button": {
      padding: 0,
      minWidth: "auto",
      "&>svg": {
        color: theme.design.color.text.secondary,
        cursor: "pointer",
        transition: ".3s",
        width: theme.design.size.icon.lg,
        height: theme.design.size.icon.lg,
        "&:hover": {
          color: theme.design.color.text.primary,
          transition: ".3s",
        },
      },
    },
  },

  contentBody: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    padding: "48px 24px 28px 24px",
    minWidth: 320,
    backgroundSize: "auto 100%",

    [theme.breakpoints.down("sm")]: {
      padding: "48px 16px 28px 16px",
    },
  },

  itemInfo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 24,
  },

  itemName: {
    color: theme.design.color.text.primary,
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,
    fontSize: 24,
  },

  itemDescription: {
    color: theme.design.color.text.primary,
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,
    fontSize: 18,
  },

  itemLand: {},

  itemInventory: {
    background: theme.design.color.surface.canvas,
    border: "1px solid",
    borderColor: theme.design.color.border.black,
    boxShadow:
      theme.design.shadow.insetStrong,


    "& img": {
      objectFit: "contain",
    },
  },

  itemIcon: {
    borderRadius: 8,
    display: "flex",
    clipPath: "content-box",
    "& img": {
      width: 100,
      padding: 1,
    },

    [theme.breakpoints.down("sm")]: {
      "& img": {
        width: 80,
        height: 80,
      },
    },
  },

  itemActions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  itemActionButton: {
    display: "flex",
    alignItems: "normal",
    gap: "8px",
    padding: "8px 32px",
    textTransform: "none",
    borderRadius: "8px",
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,
    marginTop: 8,
    minWidth: 200,
    color: theme.design.color.text.primary,
  },

  convertItemButton: {
    background: theme.design.gradient.action.danger,
  },

  sellItemButton: {
    background: theme.design.gradient.action.warning,
  },

  viewItemButton: {
    background: theme.design.gradient.action.info,
  },

  wrapItemButton: {
    background: theme.design.gradient.action.danger,
  },

  useItemButton: {
    background: theme.design.gradient.action.warning,

    "&:disabled": {
      background: theme.design.gradient.action.neutral,
      color: theme.design.color.text.secondary,
      opacity: 1,
    },
  },

  confirmSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: 32,

    gap: 16,
  },

  confirmButton: {
    backgroundColor: theme.design.color.action.primary,
  },

  confirmDescription: {
    color: theme.design.color.text.secondary,
  },

  inputBox: {
    borderRadius: "12px",
    boxSizing: "border-box",
    width: "100%",
    padding: "8px 32px",
    backgroundColor: theme.design.color.border.black,
    color: theme.design.color.text.primary,
    outline: "none",

    "& input": {
      outline: "none!important",
      border: "none",
      color: theme.design.color.text.primary,
      fontFamily: theme.design.typography.fontFamily,
      fontSize: "18px",
      fontWeight: 900,

      "&::placeholder": {
        color: theme.design.color.text.secondary,
      },
    },

    "& .MuiTextField-root::after": {
      content: "initial",
    },
  },

  amountInputBox: {
    borderRadius: "12px",
    boxSizing: "border-box",
    padding: "8px 8px",
    backgroundColor: theme.design.color.border.black,
    color: theme.design.color.text.primary,
    outline: "none",
    width: 60,

    "& input": {
      outline: "none!important",
      border: "none",
      color: theme.design.color.text.primary,
      fontFamily: theme.design.typography.fontFamily,
      fontSize: "18px",
      fontWeight: 900,

      "&::placeholder": {
        color: theme.design.color.text.secondary,
      },
    },

    "& .MuiTextField-root::after": {
      content: "initial",
    },
  },

  smallInputBox: {
    padding: "8px 12px",
  },
}));

export default styles;
